export const REQUIRED = 'שדה חובה';
